var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSProd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_721_28",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_721_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4H1V15H16V4Z",
    fill: "#FFEF5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0C15.7956 0 16.5587 0.316071 17.1213 0.87868C17.6839 1.44129 18 2.20435 18 3V15C18 15.7956 17.6839 16.5587 17.1213 17.1213C16.5587 17.6839 15.7956 18 15 18H3C2.20435 18 1.44129 17.6839 0.87868 17.1213C0.316071 16.5587 0 15.7956 0 15V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0H15ZM13.47 4.97L7 11.44L4.53 8.97C4.38783 8.83752 4.19978 8.7654 4.00548 8.76882C3.81118 8.77225 3.62579 8.85097 3.48838 8.98838C3.35097 9.12579 3.27225 9.31118 3.26883 9.50548C3.2654 9.69978 3.33752 9.88782 3.47 10.03L6.47 13.03C6.61063 13.1705 6.80125 13.2493 7 13.2493C7.19875 13.2493 7.38937 13.1705 7.53 13.03L14.53 6.03C14.6625 5.88782 14.7346 5.69978 14.7312 5.50548C14.7277 5.31118 14.649 5.12579 14.5116 4.98838C14.3742 4.85097 14.1888 4.77225 13.9945 4.76883C13.8002 4.7654 13.6122 4.83752 13.47 4.97Z",
    fill: "#FFEF5D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8467 15H13.1533M4.8467 10.3842H13.1533M14.9346 5.67608C14.8407 5.28893 14.6479 4.93282 14.375 4.64267C14.102 4.35253 13.7584 4.13831 13.3778 4.02102C12.9972 3.90373 12.5926 3.8874 12.2037 3.97363C11.8149 4.05986 11.4551 4.24569 11.1597 4.5129C10.9985 4.06951 10.7047 3.68649 10.3184 3.41584C9.93198 3.14518 9.4717 3 9 3C8.5283 3 8.06802 3.14518 7.68165 3.41584C7.29528 3.68649 7.00153 4.06951 6.84028 4.5129C6.54488 4.24569 6.18511 4.05986 5.79627 3.97363C5.40742 3.8874 5.00285 3.90373 4.62221 4.02102C4.24158 4.13831 3.89795 4.35253 3.62503 4.64267C3.35211 4.93282 3.15926 5.28893 3.0654 5.67608C2.99206 5.97821 2.98027 6.292 3.03071 6.59879C3.08115 6.90557 3.1928 7.19906 3.35901 7.46178C3.52522 7.7245 3.74259 7.95108 3.99817 8.12802C4.25376 8.30497 4.54233 8.42865 4.8467 8.49172V11.7689C4.8467 12.0138 4.94394 12.2486 5.11703 12.4217C5.29012 12.5948 5.52487 12.6921 5.76966 12.6921H12.2303C12.4751 12.6921 12.7099 12.5948 12.883 12.4217C13.0561 12.2486 13.1533 12.0138 13.1533 11.7689V8.49172C13.4577 8.42865 13.7462 8.30497 14.0018 8.12802C14.2574 7.95108 14.4748 7.7245 14.641 7.46178C14.8072 7.19906 14.9188 6.90557 14.9693 6.59879C15.0197 6.292 15.0079 5.97821 14.9346 5.67608Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSProd);
export default __webpack_public_path__ + "static/media/ico_s_prod.64d5e07ee6b1a71d95839234d2de2462.svg";
export { ForwardRef as ReactComponent };